export const DELETE_MESSAGE =
  "Համոզվա՞ծ եք, որ ցանկանում եք շարունակել այս գործողությունը: Այն հնարավոր չէ վերականգնել:";
